/* ==========================================================================
   header-v2.js — Glitter Header Redesign behavior

   Plain vanilla JS. Loaded with `defer` from sections/header-v2.liquid.
   No imports. Designed to live alongside theme.js, jQuery (product page only),
   and gift-swatches.js without interfering.

   What it does:
     - Hover-intent mega menu open/close
     - Sticky-on-scroll compact state (scrollY > 80)
     - Account dropdown toggle
     - Language dropdown toggle
     - Search dropdown show/hide on focus
     - Mobile takeover open/close + drill-in
     - Outside-click + Escape to close everything

   Cart: handled by the existing theme.js (.js-mini-cart-trigger,
   .js-slideout-open). We do NOT touch cart logic.
   ========================================================================== */
(function () {
  'use strict';

  var header = document.querySelector('.hv2');
  if (!header) return;

  var nav        = header.querySelector('[data-hv2-nav]');
  var mtake      = header.querySelector('#hv2-mtake');
  var overlay    = header.querySelector('[data-hv2-overlay]');
  var headerInner= header.querySelector('[data-hv2-header]');
  var searchWrap = header.querySelector('[data-hv2-search]');
  var searchInput= header.querySelector('[data-hv2-search-input]');
  var accountWrap= header.querySelector('[data-hv2-account]');
  var langWrap   = header.querySelector('[data-hv2-lang]');

  /* -------------------------------------------------------------- *
   *  STICKY SCROLL  (closeMegaFn assigned later by mega menu block)
   * -------------------------------------------------------------- */
  var STICKY_THRESHOLD = 80;
  var lastStuck = false;
  var closeMegaFn = null;
  function onScroll() {
    var stuck = window.scrollY > STICKY_THRESHOLD;
    if (stuck !== lastStuck) {
      headerInner.classList.toggle('is-stuck', stuck);
      if (stuck && closeMegaFn) closeMegaFn();
      lastStuck = stuck;
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* -------------------------------------------------------------- *
   *  MEGA MENU (hover intent + click toggle)
   * -------------------------------------------------------------- */
  if (nav) {
    var navItems = nav.querySelectorAll('[data-nav-key][data-has-mega="true"]');
    var megaWraps = nav.querySelectorAll('.gg-mega-wrap');
    var openTimer = null;
    var closeTimer = null;
    var currentKey = null;

    function megaWrapForKey(key) {
      for (var i = 0; i < megaWraps.length; i++) {
        if (megaWraps[i].getAttribute('data-mega-key') === key) return megaWraps[i];
      }
      return null;
    }
    function navItemForKey(key) {
      for (var i = 0; i < navItems.length; i++) {
        if (navItems[i].getAttribute('data-nav-key') === key) return navItems[i];
      }
      return null;
    }

    function openMega(key) {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (currentKey === key) return;

      // Close existing
      if (currentKey) {
        var prevWrap = megaWrapForKey(currentKey);
        var prevItem = navItemForKey(currentKey);
        if (prevWrap) { prevWrap.classList.remove('is-open'); prevWrap.setAttribute('aria-hidden', 'true'); }
        if (prevItem) {
          prevItem.classList.remove('is-open');
          var btn = prevItem.querySelector('[data-nav-toggle]');
          if (btn) btn.setAttribute('aria-expanded', 'false');
        }
      }

      var wrap = megaWrapForKey(key);
      var item = navItemForKey(key);
      if (wrap) { wrap.classList.add('is-open'); wrap.setAttribute('aria-hidden', 'false'); }
      if (item) {
        item.classList.add('is-open');
        var btn2 = item.querySelector('[data-nav-toggle]');
        if (btn2) btn2.setAttribute('aria-expanded', 'true');
      }
      currentKey = key;
    }

    function closeMega() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (!currentKey) return;
      var wrap = megaWrapForKey(currentKey);
      var item = navItemForKey(currentKey);
      if (wrap) { wrap.classList.remove('is-open'); wrap.setAttribute('aria-hidden', 'true'); }
      if (item) {
        item.classList.remove('is-open');
        var btn = item.querySelector('[data-nav-toggle]');
        if (btn) btn.setAttribute('aria-expanded', 'false');
      }
      currentKey = null;
    }
    closeMegaFn = closeMega;

    function scheduleOpen(key) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      if (openTimer) clearTimeout(openTimer);
      openTimer = setTimeout(function () { openMega(key); }, 100);
    }
    function scheduleClose() {
      if (openTimer) { clearTimeout(openTimer); openTimer = null; }
      if (closeTimer) clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { closeMega(); }, 150);
    }

    // Per-item hover intent + click toggle
    navItems.forEach(function (item) {
      var key = item.getAttribute('data-nav-key');
      var btn = item.querySelector('[data-nav-toggle]');

      item.addEventListener('mouseenter', function () { scheduleOpen(key); });
      item.addEventListener('mouseleave', function () { scheduleClose(); });

      if (btn) {
        btn.addEventListener('click', function (e) {
          // For spotlight pill which is an <a>, don't preventDefault unless menu opens via click
          if (btn.tagName === 'BUTTON') {
            e.preventDefault();
            if (currentKey === key) closeMega(); else openMega(key);
          }
        });
        btn.addEventListener('focus', function () { scheduleOpen(key); });
      }
    });

    // Keep mega open while hovering it
    megaWraps.forEach(function (wrap) {
      wrap.addEventListener('mouseenter', function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });
      wrap.addEventListener('mouseleave', function () { scheduleClose(); });
    });

    // Close mega on outside click
    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) closeMega();
    });
  }

  /* -------------------------------------------------------------- *
   *  ACCOUNT DROPDOWN
   * -------------------------------------------------------------- */
  if (accountWrap) {
    var accountToggle = accountWrap.querySelector('[data-hv2-account-toggle]');
    var accountMenu   = accountWrap.querySelector('.gg-dropdown');
    if (accountToggle && accountMenu) {
      accountToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = accountMenu.classList.toggle('is-open');
        accountToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!accountWrap.contains(e.target)) {
          accountMenu.classList.remove('is-open');
          accountToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  /* -------------------------------------------------------------- *
   *  LANGUAGE DROPDOWN
   * -------------------------------------------------------------- */
  if (langWrap) {
    var langToggle = langWrap.querySelector('[data-hv2-lang-toggle]');
    var langMenu   = langWrap.querySelector('.gg-lang-menu');
    if (langToggle && langMenu) {
      langToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = langMenu.classList.toggle('is-open');
        langToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      document.addEventListener('click', function (e) {
        if (!langWrap.contains(e.target)) {
          langMenu.classList.remove('is-open');
          langToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }
  }

  /* -------------------------------------------------------------- *
   *  SEARCH DROPDOWN — fetch Shopify predictive search suggestions
   *  ourselves and inject the rendered predictive-search section into
   *  #hv2-predictive-results. Native form submit (Enter) is untouched.
   * -------------------------------------------------------------- */
  if (searchWrap && searchInput) {
    var searchPanel = searchWrap.querySelector('.gg-search-dropdown');
    function showSearchPanel() {
      if (searchPanel) { searchPanel.hidden = false; }
      searchWrap.classList.add('is-open');
    }
    function hideSearchPanel() {
      if (searchPanel) { searchPanel.hidden = true; }
      searchWrap.classList.remove('is-open');
    }
    searchInput.addEventListener('focus', showSearchPanel);
    document.addEventListener('click', function (e) {
      if (!searchWrap.contains(e.target)) hideSearchPanel();
    });

    if (searchPanel) {
      var suggestBase = searchPanel.dataset.hv2SuggestUrl || '/search/suggest';
      var suggestTimer = null;
      var suggestController = null;

      function fetchSuggestions(term) {
        if (suggestController) { suggestController.abort(); }
        suggestController = new AbortController();
        var url = suggestBase
          + '?q=' + encodeURIComponent(term)
          + '&section_id=predictive-search'
          + '&resources[options][fields]=title,product_type,variants.title,vendor,variants.sku';
        fetch(url, { signal: suggestController.signal })
          .then(function (res) {
            if (!res.ok) throw new Error(res.status);
            return res.text();
          })
          .then(function (text) {
            var doc = new DOMParser().parseFromString(text, 'text/html');
            var section = doc.querySelector('#shopify-section-predictive-search');
            if (!section) { hideSearchPanel(); return; }
            searchPanel.innerHTML = section.innerHTML;
            showSearchPanel();
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            hideSearchPanel();
            console.warn('[header-v2] predictive search failed:', err);
          });
      }

      searchInput.addEventListener('input', function () {
        var term = searchInput.value;
        if (suggestTimer) { clearTimeout(suggestTimer); }
        if (term.trim().length < 2) {
          if (suggestController) { suggestController.abort(); suggestController = null; }
          searchPanel.innerHTML = '';
          hideSearchPanel();
          return;
        }
        suggestTimer = setTimeout(function () {
          fetchSuggestions(term);
        }, 200);
      });
    }
  }

  /* -------------------------------------------------------------- *
   *  MOBILE TAKEOVER
   * -------------------------------------------------------------- */
  if (mtake) {
    var openButtons   = header.querySelectorAll('[data-mtake-open], [data-mtake-open-search]');
    var closeButton   = mtake.querySelector('[data-mtake-close]');
    var backButton    = mtake.querySelector('[data-mtake-back]');
    var backLabelEl   = mtake.querySelector('[data-mtake-back-label]');
    var defaultLogoEl = mtake.querySelector('.gg-mtake-logo-default');
    var drillButtons  = mtake.querySelectorAll('[data-mtake-drill]');
    var subPanels     = mtake.querySelectorAll('[data-mtake-panel]');
    var searchOpenBtn = header.querySelector('[data-mtake-open-search]');
    var mtakeSearchInput = mtake.querySelector('input[type="search"]');

    /* -------------------------------------------------------------- *
     *  Hide ALL fixed-position page widgets (chat, translate, etc) while
     *  the takeover is open so they don't cover the takeover footer.
     *  We track each one's prior visibility so we can restore on close.
     *  Uses visibility (not display:none) so the widget DOM stays intact
     *  and its own JS doesn't re-init/glitch on restore.
     * -------------------------------------------------------------- */
    var hiddenWidgets = [];
    // Targeted selector list — covers all common chat / translate / messenger
    // / signup / popup widgets without scanning every DOM node. Specifically
    // EXCLUDES the Giftship drawer cart (#slideout-ajax-cart) so it remains
    // visible/operational. Idempotent: skips already-tracked elements.
    var FIXED_WIDGET_SELECTORS = [
      // Shopify Inbox / chat
      '#shopify-chat', 'iframe.shopify-chat-iframe', '[data-pf-type="shopify_chat"]',
      'shopify-buy-it-now-button', '[id^="shopify-chat"]', '[class*="shopify-chat"]',
      // Crisp
      '#crisp-chatbox', '.crisp-client',
      // Tidio
      '#tidio-chat', '.tidio-chat', '#tidio-chat-iframe',
      // Intercom
      '.intercom-launcher', '.intercom-lightweight-app', 'iframe.intercom-launcher-frame',
      // Drift
      '#drift-frame-chat', '#drift-frame-controller', 'iframe[name="drift_iframe"]',
      // Gorgias
      '#gorgias-chat-container', '#gorgias-chat-bubble-button',
      // Tawk / Freshchat
      '.tawk-min-container', 'iframe.fc-widget-normal-iframe', '.fc-widget-normal',
      // Facebook Messenger plugin
      '#fb-customer-chat', '.fb_dialog',
      // Google Translate (full coverage)
      '#google_translate_element', '.goog-te-banner-frame', '.skiptranslate',
      '.goog-te-gadget', '.goog-te-menu-frame', 'iframe.goog-te-menu-frame',
      'iframe[name="goog-gt-tt"]', '#goog-gt-tt',
      // Klaviyo
      '.klaviyo-form', '[class*="klaviyo-onsite"]',
      // HubSpot
      '[id^="hubspot-messages"]', '.hubspot-messages-iframe-container',
      // Bitrix24
      '.b24-widget-button-wrapper',
      // Zopim
      '.zopim',
      // Olark
      '.olrk-launch-frame',
      // Generic catch-all heuristics — chat / launcher / messenger iframes
      'iframe[title*="chat" i]', 'iframe[title*="message" i]',
      'iframe[src*="chat"]', 'iframe[src*="messenger"]',
      '[class*="ChatBot" i]', '[class*="livechat" i]',
      '[class*="chat-widget" i]', '[id*="chat-widget" i]',
      '[class*="messenger" i][class*="launcher" i]'
      // NOTE: sticky ATC is handled via pure CSS (body.hv2-mtake-open .mdp-sticky-atc)
      // not JS — JS-driven visibility on multiple position:fixed elements can cause
      // iOS Safari paint glitches that blanked the takeover panel itself.
    ].join(',');

    function tryHide(el) {
      if (!el || el.nodeType !== 1) return;
      if (el.dataset && el.dataset.hv2PrevVis !== undefined) return;
      if (el.closest && el.closest('.hv2-section')) return;
      if (el === mtake || (mtake.contains && mtake.contains(el))) return;
      var tag = el.tagName;
      if (tag === 'SCRIPT' || tag === 'STYLE' || tag === 'LINK' || tag === 'NOSCRIPT' || tag === 'META') return;
      var cs = window.getComputedStyle(el);
      if (cs.visibility === 'hidden' || cs.display === 'none') return;
      el.dataset.hv2PrevVis = el.style.visibility || '';
      el.style.visibility = 'hidden';
      hiddenWidgets.push(el);
    }
    function hideFixedWidgets() {
      // Pass 1 — hide all elements matching our curated selector list (covers deep-nested chat iframes).
      var matched = document.querySelectorAll(FIXED_WIDGET_SELECTORS);
      for (var i = 0; i < matched.length; i++) tryHide(matched[i]);
      // Pass 2 — safety net: hide ANY direct child of <body> that is position:fixed.
      // This is fast (only ~30 children typically) and catches widgets we don't
      // have a curated selector for. Excludes our own header section, scripts, etc.
      var children = document.body.children;
      for (var j = 0; j < children.length; j++) {
        var child = children[j];
        var ccs = window.getComputedStyle(child);
        if (ccs.position === 'fixed') tryHide(child);
      }
    }
    function restoreFixedWidgets() {
      hiddenWidgets.forEach(function (el) {
        el.style.visibility = el.dataset.hv2PrevVis || '';
        delete el.dataset.hv2PrevVis;
      });
      hiddenWidgets = [];
    }

    function openMtake(focusSearch) {
      mtake.classList.add('is-open');
      mtake.setAttribute('aria-hidden', 'false');
      document.body.classList.add('hv2-mtake-open');
      if (overlay) overlay.classList.add('is-on');
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      hideFixedWidgets();
      // Re-run after delays to catch chat widgets that render late
      setTimeout(hideFixedWidgets, 200);
      setTimeout(hideFixedWidgets, 800);
      if (focusSearch && mtakeSearchInput) {
        setTimeout(function () { mtakeSearchInput.focus(); }, 320);
      }
    }
    function closeMtake() {
      mtake.classList.remove('is-open');
      mtake.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('hv2-mtake-open');
      if (overlay) overlay.classList.remove('is-on');
      openButtons.forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      restoreFixedWidgets();
      // Reset drill state after slide-out animation
      setTimeout(function () {
        mtake.classList.remove('has-sub');
        subPanels.forEach(function (p) { p.classList.remove('is-active'); p.hidden = true; });
        if (backButton) backButton.hidden = true;
        if (defaultLogoEl) defaultLogoEl.hidden = false;
      }, 300);
    }
    function drillTo(handle, label) {
      var panel = mtake.querySelector('[data-mtake-panel="' + handle + '"]');
      if (!panel) return;
      subPanels.forEach(function (p) {
        if (p === panel) {
          p.hidden = false;
          p.classList.add('is-active');
        } else {
          p.classList.remove('is-active');
          p.hidden = true;
        }
      });
      mtake.classList.add('has-sub');
      if (backButton) backButton.hidden = false;
      if (backLabelEl) backLabelEl.textContent = label || 'Back';
      if (defaultLogoEl) defaultLogoEl.hidden = true;
    }
    function drillBack() {
      mtake.classList.remove('has-sub');
      if (backButton) backButton.hidden = true;
      if (defaultLogoEl) defaultLogoEl.hidden = false;
      // Reset panel state slightly after the slide-out
      setTimeout(function () {
        subPanels.forEach(function (p) { p.classList.remove('is-active'); p.hidden = true; });
      }, 300);
    }

    openButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isSearch = btn.hasAttribute('data-mtake-open-search');
        openMtake(isSearch);
      });
    });
    if (closeButton) closeButton.addEventListener('click', closeMtake);
    if (backButton)  backButton.addEventListener('click', drillBack);

    drillButtons.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        // Tiles are anchors so the default action would navigate; intercept and drill instead.
        e.preventDefault();
        var key = btn.getAttribute('data-mtake-drill');
        var lbl = btn.getAttribute('data-mtake-label');
        drillTo(key, lbl);
      });
    });

    if (overlay) overlay.addEventListener('click', closeMtake);
  }

  /* -------------------------------------------------------------- *
   *  ESCAPE KEY closes everything
   * -------------------------------------------------------------- */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (mtake && mtake.classList.contains('is-open')) {
      var closeBtn = mtake.querySelector('[data-mtake-close]');
      if (closeBtn) closeBtn.click();
      return;
    }
    if (nav) {
      var openItem = nav.querySelector('.gg-nav-item.is-open');
      if (openItem) openItem.classList.remove('is-open');
      nav.querySelectorAll('.gg-mega-wrap.is-open').forEach(function (w) {
        w.classList.remove('is-open'); w.setAttribute('aria-hidden', 'true');
      });
    }
    if (accountWrap) {
      var am = accountWrap.querySelector('.gg-dropdown');
      if (am) am.classList.remove('is-open');
    }
    if (langWrap) {
      var lm = langWrap.querySelector('.gg-lang-menu');
      if (lm) lm.classList.remove('is-open');
    }
  });

  /* -------------------------------------------------------------- *
   *  SHIP-TODAY CHIP — client-side state + countdown
   *  Pages can be cached by Shopify's edge for hours; the server's
   *  state snapshot ('before_cutoff' vs 'after_cutoff') goes stale.
   *  This refreshes from Date.now() on every load + every second so
   *  the chip is always accurate regardless of cache freshness.
   *
   *  Server emits TWO message variants in data attributes; we pick
   *  the right one based on now vs cutoff Unix.
   * -------------------------------------------------------------- */
  function refreshShipRows() {
    var rows = document.querySelectorAll('.hv2-ship-row[data-ship-cutoff]');
    if (!rows.length) return;
    var now = Math.floor(Date.now() / 1000);
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var cutoff = parseInt(row.getAttribute('data-ship-cutoff'), 10) || 0;
      var msgBefore = row.getAttribute('data-ship-msg-before') || '';
      var msgAfter  = row.getAttribute('data-ship-msg-after')  || '';
      var isBefore = cutoff > 0 && now < cutoff;
      row.classList.toggle('is-before', isBefore);
      row.classList.toggle('is-after', !isBefore);

      var textEl = row.querySelector('.hv2-ship-row__text');
      if (!textEl) continue;

      if (isBefore) {
        var diff = cutoff - now;
        if (diff < 0) diff = 0;
        var h = Math.floor(diff / 3600);
        var m = Math.floor((diff % 3600) / 60);
        var s = diff % 60;
        var countdownSpan = '<span class="hv2-ship-countdown">' + h + 'h ' + m + 'm ' + s + 's</span>';
        textEl.innerHTML = msgBefore
          .replace('{countdown}', countdownSpan)
          .replace('{hours}', h)
          .replace('{minutes}', m)
          .replace('{seconds}', s);
      } else {
        textEl.innerHTML = msgAfter;
      }
    }
  }
  refreshShipRows();
  setInterval(refreshShipRows, 1000);

  /* -------------------------------------------------------------- *
   *  CART BADGE — keep .is-zero class in sync with the count text.
   *  Theme.js / Giftship update .js-cart-count's text on Ajax add
   *  but don't touch our .is-zero class. Without this observer the
   *  badge stays display:none after the first item is added.
   * -------------------------------------------------------------- */
  // Find an authoritative cart count from any .js-cart-count element on the
  // page that's OUTSIDE our header (e.g. the snippet inside cart-form.liquid
  // renders "({{ cart.item_count }})" next to the Clear Cart button — that
  // value is reliably correct even when our header badge gets wiped by
  // theme.js or by stale section-cache HTML).
  function findAuthoritativeCartCount() {
    var els = document.querySelectorAll('.js-cart-count');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.closest && el.closest('.hv2-section')) continue;
      var t = (el.textContent || '').trim();
      var match = t.match(/\d+/);
      if (match) return match[0];
    }
    return null;
  }

  function syncCartZero() {
    var badges = document.querySelectorAll('.gg-cart-badge');
    if (!badges.length) return;

    // Source of truth, in order:
    //   1. Authoritative count from any non-header .js-cart-count on the page
    //      (e.g. cart-form's "({{ cart.item_count }})" next to Clear Cart)
    //   2. Digits already in the badge's own text
    //   3. data-hv2-server-count attribute (Liquid render-time fallback)
    var authoritative = findAuthoritativeCartCount();

    for (var i = 0; i < badges.length; i++) {
      var b = badges[i];
      var t = (b.textContent || '').trim();
      var match = t.match(/\d+/);
      var clean = '';

      if (authoritative != null) {
        clean = authoritative;
      } else if (match) {
        clean = match[0];
      } else if (b.dataset && b.dataset.hv2ServerCount != null) {
        clean = String(b.dataset.hv2ServerCount);
      }

      if (clean !== '') {
        // Write clean digits to textContent (visible) AND data-count + dataset (fallbacks).
        if (t !== clean) b.textContent = clean;
        if (b.getAttribute('data-count') !== clean) b.setAttribute('data-count', clean);
        if (b.dataset && 'hv2ServerCount' in b.dataset) b.dataset.hv2ServerCount = clean;
      }
      // Hide on explicit zero
      b.classList.toggle('is-zero', clean === '0');
    }
  }
  syncCartZero();
  if (window.MutationObserver) {
    var cartObs = new MutationObserver(syncCartZero);
    document.querySelectorAll('.js-cart-count').forEach(function (el) {
      cartObs.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }
  // Brute-force cleanup for the first 3 seconds in case theme.js writes "(5)"
  // to .js-cart-count AFTER our deferred header-v2.js has already attached the
  // observer (rare but possible if theme.js dispatches its initial cart hydrate
  // through a script tag that runs after defer'd scripts on some setups).
  var cleanCount = 0;
  var cleanInterval = setInterval(function () {
    syncCartZero();
    if (++cleanCount > 30) clearInterval(cleanInterval);
  }, 100);

  /* -------------------------------------------------------------- *
   *  CART COUNT REFETCH — fixes a pre-existing theme bug where
   *  changing quantities on the /cart page updates the line items
   *  via Ajax but doesn't update the header's .js-cart-count text.
   *  We fetch /cart.js after any cart-mutation signal and write the
   *  fresh item_count into every .js-cart-count element. The MutationObserver
   *  above then re-syncs the .is-zero class so the badge shows/hides
   *  correctly.
   * -------------------------------------------------------------- */
  var refetchTimer = null;
  function refetchCartCount() {
    if (refetchTimer) clearTimeout(refetchTimer);
    refetchTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (!data || data.item_count == null) return;
          var count = String(data.item_count);
          // Our header badges (.gg-cart-badge): update data-count, textContent, is-zero.
          document.querySelectorAll('.gg-cart-badge').forEach(function (el) {
            el.setAttribute('data-count', count);
            el.textContent = count;
            el.classList.toggle('is-zero', data.item_count === 0);
            if (el.dataset && 'hv2ServerCount' in el.dataset) {
              el.dataset.hv2ServerCount = count;
            }
          });
          // External .js-cart-count elements (e.g. cart-form): keep textContent in sync.
          document.querySelectorAll('.js-cart-count').forEach(function (el) {
            var current = (el.textContent || '').trim();
            if (current !== count && (data.item_count > 0 || current === '0' || current === '')) {
              el.textContent = count;
            }
          });
        })
        .catch(function () { /* swallow — non-critical */ });
    }, 250);
  }

  // Listen for common cart-update custom events dispatched by various theme/app
  // libraries (Shopify defaults, older Underground theme, Giftship, AJAX cart apps).
  ['cart:updated', 'cart:update', 'cart:change', 'cart:refresh',
   'ajaxCart:afterCartUpdate', 'ajax-cart:updated', 'ajaxCart:updated',
   'cart.requestComplete'].forEach(function (evt) {
    document.addEventListener(evt, refetchCartCount);
  });

  // On the /cart page specifically, watch for quantity-adjuster signals.
  // Underground theme uses input[name="updates[]"] and +/- buttons.
  if (window.location.pathname === '/cart' || window.location.pathname === '/cart/') {
    document.addEventListener('change', function (e) {
      if (!e.target || !e.target.matches) return;
      if (e.target.matches('input[name="updates[]"], input[name*="quantity"], input[type="number"][data-cart-qty]')) {
        refetchCartCount();
      }
    });
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('button, a');
      if (!btn) return;
      // Heuristic: button inside a .qty / .quantity wrapper
      if (btn.closest('[class*="qty"], [class*="quantity"], [data-qty]')) {
        refetchCartCount();
      }
    });
  }
  // Post-load reconciliation: at 2 seconds after load (well after Shopify session
  // is fully hydrated), fetch /cart.js once and force the badge to match the
  // authoritative cart count. This handles the case where Shopify's section-level
  // edge cache served HTML with a stale cart.item_count (e.g. cart was empty when
  // header section was cached, but the visitor's actual cart now has items).
  // Forces the result through even if the badge has is-zero class.
  setTimeout(function () {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.item_count == null) return;
        var count = String(data.item_count);
        document.querySelectorAll('.gg-cart-badge').forEach(function (el) {
          el.setAttribute('data-count', count);
          if ((el.textContent || '').trim() !== count) el.textContent = count;
          el.classList.toggle('is-zero', data.item_count === 0);
          if (el.dataset && 'hv2ServerCount' in el.dataset) {
            el.dataset.hv2ServerCount = count;
          }
        });
        document.querySelectorAll('.js-cart-count').forEach(function (el) {
          if ((el.textContent || '').trim() !== count) el.textContent = count;
        });
      })
      .catch(function () { /* swallow */ });
  }, 2000);
})();
